export default "__VITE_ASSET__07bb6405__"